import { Box, CircularProgress } from '@mui/material';

export const Loading = ({ isLoading }: { isLoading: boolean }) => {
  if (!isLoading) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <CircularProgress data-testid="fim3-loading" />
    </Box>
  );
};
